// 本人希望欄（新卒向け履歴書）の選択肢リスト
// NewRirekishoEdit.vue の data() と同値。マイページのヤギオファー用プロフィールと共有する
export const PREF_OPTIONS = [
  '北海道',
  '青森県',
  '岩手県',
  '宮城県',
  '秋田県',
  '山形県',
  '福島県',
  '茨城県',
  '栃木県',
  '群馬県',
  '埼玉県',
  '千葉県',
  '東京都',
  '神奈川県',
  '新潟県',
  '富山県',
  '石川県',
  '福井県',
  '山梨県',
  '長野県',
  '岐阜県',
  '静岡県',
  '愛知県',
  '三重県',
  '滋賀県',
  '京都府',
  '大阪府',
  '兵庫県',
  '奈良県',
  '和歌山県',
  '鳥取県',
  '島根県',
  '岡山県',
  '広島県',
  '山口県',
  '徳島県',
  '香川県',
  '愛媛県',
  '高知県',
  '福岡県',
  '佐賀県',
  '長崎県',
  '熊本県',
  '大分県',
  '宮崎県',
  '鹿児島県',
  '沖縄県',
  '海外'
]

export const HOPE_INDUSTRY_OPTIONS = [
  'IT・通信',
  'ソフトウェア・情報処理',
  'インターネット関連・ゲーム・アプリ関連',
  '機械・産業用装置・電機・OA機器',
  '自動車・自動車部品・輸送用機器',
  'コンピュータ・通信機器・精密機器',
  '電子部品・半導体',
  '食品・飲料・たばこ・飼料',
  '化学・医薬・化粧品',
  '鉄鋼・非鉄金属・金属製品',
  '石油・石炭・ゴム・プラスチック',
  'ガラス・セラミック・セメント',
  'パルプ・紙・紙加工・印刷・印刷関連',
  '日用品・文具・オフィス用品',
  '建材・エクステリア',
  'インテリア・住宅関連',
  'アパレル・服飾関連',
  'スポーツ・玩具・ゲーム機器',
  'その他メーカー・製造関連',
  '電気・ガス・石油・水道',
  '放送（テレビ・ラジオ含む）',
  '新聞・出版',
  '広告',
  'その他（芸能・エンタテインメント関連等）',
  '運輸（鉄道・航空・海運・物流等）',
  '総合商社',
  '専門商社',
  '百貨店・スーパー・ドラッグストア・コンビニ・ホームセンター',
  '通信販売、専門店・その他小売り',
  '銀行（協同組織金融含む）',
  '証券',
  '保険',
  'その他金融（クレジット等）',
  'リース・レンタル',
  'ディベロッパー',
  '建設・建築設計・ハウスメーカー',
  '設備関連',
  'プラント・プラントエンジニアリング',
  '不動産取引・不動産賃貸・不動産管理',
  'デザイン・芸術関連',
  'コンサルティング・マーケティング・調査',
  'その他専門・技術サービス',
  'ホテル・旅館',
  '外食',
  'その他フード',
  '理美容・エステ・フィットネスクラブ',
  '旅行・観光',
  '家事サービス・クリーニング',
  '冠婚葬祭',
  'その他生活関連サービス',
  'アミューズメント・レジャーサービス',
  '教育関連',
  '医療・保育・介護、福祉',
  '環境・リサイクル・廃棄物処理',
  '整備・修理',
  '人材サービス',
  'その他事業サービス（警備、コールセンター等）',
  'その他'
]

export const HOPE_JOBCATEGORY_OPTIONS = [
  '営業',
  '事務・秘書・受付',
  '経理',
  '総務人事',
  'バイヤー',
  '法務',
  '知的財産部門',
  '企画',
  'マーケティング',
  '宣伝・広報',
  '経営企画',
  '経営コンサルタント',
  '為替ディーラー・トレーダー',
  '証券アナリスト',
  '融資・資産運用(ファンドマネージャー等）',
  'ファイナンシャルアドバイザー',
  'アクチュアリー',
  'システムエンジニア・プログラマ',
  'Webエンジニア',
  'ネットワークエンジニア',
  'セキュリティエンジニア',
  'インフラ・データエンジニア',
  'AIエンジニア',
  '組み込みエンジニア',
  'カスタマーエンジニア',
  '社内SE・情シス',
  '研究職（製造系）',
  '設計開発',
  '生産・製造',
  '物流・在庫管理',
  'セールスエンジニア',
  '品質管理',
  '医療技術',
  'MR（医薬情報担当者）',
  '研究開発（医薬系）',
  '薬剤師',
  '栄養士',
  '福祉士・介護士・ホームヘルパー',
  '講師・インストラクター',
  '専門コンサルタント',
  '建築・土木設計',
  '施工管理',
  'Webプロデューサー・ディレクター',
  'Webデザイナー',
  'デザイナー',
  'ゲームクリエイター',
  'ゲームプログラマ',
  'データサイエンティスト・アナリスト',
  '記者・ライター',
  '編集・制作',
  '販売・接客',
  '店長（店舗経営・運営）',
  'スーパーバイザー',
  '農業',
  '林業',
  '漁業'
]
